import { MutationCache, QueryClient } from 'react-query';

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      retry: false
    }
  },
  mutationCache: new MutationCache({
    // React Query's global mutation callbacks do not reliably distinguish
    // per-call mutate({ onError }) handlers in this codebase, which caused
    // duplicate toasts. Keep centralized logging here and let screens/hooks
    // own user-facing notifications.
    onError: (err, _variables, _context, mutation) => {
      if (mutation.options.onError) return;
      console.error('MutationCache global onError:', err);
    }
  })
});
